import { render, staticRenderFns } from "./ShoppingOrders.vue?vue&type=template&id=5d0adaef&"
import script from "./ShoppingOrders.vue?vue&type=script&lang=js&"
export * from "./ShoppingOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports